import React from "react";

export function BrandMark() {
  return (
    <svg width="38" height="38" viewBox="0 0 64 64" role="img" aria-label="Логотип">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#7C4DFF" />
          <stop offset="1" stopColor="#FF4D8D" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="18" fill="url(#g)" />
      <path
        d="M18 46V18h10.8c6.2 0 10.4 3.4 10.4 8.8 0 5.3-4.2 8.8-10.4 8.8H25.6V46H18Zm7.6-16.8h2.8c2.6 0 4-1.0 4-2.7 0-1.7-1.4-2.7-4-2.7h-2.8v5.4Z"
        fill="rgba(255,255,255,0.96)"
      />
    </svg>
  );
}